import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Transition from 'react-transition-group/Transition';

class Card extends Component {
    state = {
        in: false
    }

    componentDidMount() {
        this.setState({in: true})
    }

    render() {
        const defaultStyle = {
            transition: 'opacity 500ms ease-in-out',
            opacity: 0,
        }
        const transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 }
        }
        return (
            <Transition in={this.state.in} timeout={250}>
                {
                (state) => {
                    return (
                    <div className={`card col-xl-5 ${css(styles.projectCard)}`} style={{...defaultStyle, ...transitionStyles[state]}} >
                    <img className="card-img-top" src={this.props.dataObj.img} />
                    <div className={`card-body ${css(styles.cBody)}`}>
                        <h3 className={`card-title ${css(styles.title)}`}>{this.props.dataObj.name}</h3>
                        <p className="card-tex7t">{this.props.dataObj.desc}</p>
                        <div className={`row ${css(styles.linkDiv)}`}>
                        <div className={`col-6 ${css(styles.linkDiv)}`}><a className={css(styles.link)} href={this.props.dataObj.link} target="_blank">Link</a></div>
                        <div className='col-6 link'><a className={css(styles.link)} href={this.props.dataObj.ghub} target="_blank">Github</a></div>
                        </div>
                    </div>
                    
                    </div>
                )}} 
            </Transition>
        )
    }
}

const styles = StyleSheet.create({
    projectCard: {
      marginTop: '3vh',
      background: 'none',
      border: 'none',
      color: '#ACAA9C'
    },
    cBody: {
      background: 'rgba(43,43,47, 0.75)'   
    },
    linkDiv: {
      background: 'none',
      border: 'none'
    },
    link: {
      fontSize: '1.5em',
      color: '#f5b779',
      textDecoration: 'none',
      ':hover': {
        color: '#ff9c23'
      },
      '@media (max-width: 1390px)': {
          fontSize: '1em'
      }
    },
    title: {
      fontSize: '2.5em',
      fontFamily: 'Squada One'
    }
});

export default Card;


// WEBPACK FOOTER //
// ./src/components/card/card.js